/**
 * @generated SignedSource<<e9ef18b7749ca2c825b39db4b8c20ee0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type MarketPlaceProviders = "APP_SUMO" | "CASA_DE_LAS_CARCASAS" | "FAVORITE_GIFT" | "HP" | "MICROSOFT_AZURE" | "VERSORI";
export type PricingVersion = "VERSION_1" | "VERSION_2";
export type ZakekeEnvironment = "AI_STUDIO" | "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
import { FragmentRefs } from "relay-runtime";
export type useSubscriptionData_subscriptionDataFragment$data = {
  readonly ecommerceSettings: {
    readonly ecommerceName: ECommerce;
  } | null;
  readonly salesChannels?: ReadonlyArray<{
    readonly ecommerceSettings: {
      readonly currencyCode: string | null;
      readonly ecommerceName: ECommerce;
      readonly isMarketplace: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
  readonly seller: {
    readonly marketplace: MarketPlaceProviders | null;
  } | null;
  readonly shopifyAuthEcommerceSettings: {
    readonly environment: ZakekeEnvironment;
    readonly installed: boolean;
    readonly isTestStore: boolean;
    readonly shop: string | null;
  } | null;
  readonly subscription: {
    readonly addons: ReadonlyArray<{
      readonly addonID: number;
      readonly name: string;
      readonly startDate: string;
    }>;
    readonly areSalesChannelsEnabled: boolean;
    readonly inTrial: boolean;
    readonly isAdvancedPricingEnabled: boolean;
    readonly isCmykEnabled: boolean;
    readonly isOnCustomPlan: boolean;
    readonly isPantoneEnabled: boolean;
    readonly isPdfEpsEnabled: boolean;
    readonly isProfanityChecksEnabled: boolean;
    readonly isSinglePrintFileEnabled: boolean;
    readonly plan: {
      readonly additionalFeatures: {
        readonly advancedPrintFilesBuilder: boolean;
        readonly aiPoweredTools: boolean;
        readonly bulkVariationForm: boolean;
        readonly configuratorLinks: boolean;
        readonly customEnvironmentTexture: boolean;
        readonly customInterface: boolean;
        readonly dynamicProperties: boolean;
        readonly editPDFPreview: boolean;
        readonly editPrintfiles: boolean;
        readonly editSummary: boolean;
        readonly engraving: boolean;
        readonly extraOptions: boolean;
        readonly getAQuote: boolean;
        readonly integrations: boolean;
        readonly largeFile: boolean;
        readonly materialLibrary: boolean;
        readonly moq: boolean;
        readonly multiareaConfiguratorDesigner: boolean;
        readonly pricePerImage: boolean;
        readonly prices3dConfigurator: boolean;
        readonly printReadyFilesPlus: boolean;
        readonly profanityFilter: boolean;
        readonly standalone: boolean;
        readonly textplus: boolean;
        readonly vectorization: boolean;
      };
      readonly currencyCode: string;
      readonly description: string;
      readonly isCustom: boolean;
      readonly maxSizeStorageMB: number;
      readonly name: string;
      readonly salesChannelPrice: number;
      readonly version: number;
    } | null;
    readonly planId: number;
    readonly planName: string | null;
    readonly planVersion: PricingVersion;
    readonly profileDescription: string | null;
    readonly profileName: string | null;
    readonly remainingTrialDays: number;
    readonly trialEnd: string | null;
  } | null;
  readonly " $fragmentType": "useSubscriptionData_subscriptionDataFragment";
};
export type useSubscriptionData_subscriptionDataFragment$key = {
  readonly " $data"?: useSubscriptionData_subscriptionDataFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSubscriptionData_subscriptionDataFragment">;
};

import SubscriptionDataFragmentRefetchQuery_graphql from './SubscriptionDataFragmentRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "canReadChannels"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": SubscriptionDataFragmentRefetchQuery_graphql
    }
  },
  "name": "useSubscriptionData_subscriptionDataFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ZakekeSubscription",
      "kind": "LinkedField",
      "name": "subscription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPantoneEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSinglePrintFileEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCmykEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPdfEpsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdvancedPricingEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isProfanityChecksEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOnCustomPlan",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "areSalesChannelsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inTrial",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingTrialDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "trialEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PlanGraphql",
          "kind": "LinkedField",
          "name": "plan",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxSizeStorageMB",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salesChannelPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCustom",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AdditionalPlanFeatures",
              "kind": "LinkedField",
              "name": "additionalFeatures",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "editPDFPreview",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "editSummary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "integrations",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "bulkVariationForm",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pricePerImage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "engraving",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "editPrintfiles",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "printReadyFilesPlus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "textplus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "prices3dConfigurator",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customEnvironmentTexture",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dynamicProperties",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "materialLibrary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "multiareaConfiguratorDesigner",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "advancedPrintFilesBuilder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "aiPoweredTools",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "getAQuote",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customInterface",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profanityFilter",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "largeFile",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "configuratorLinks",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "vectorization",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "moq",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "extraOptions",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "standalone",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SubscriptionAddon",
          "kind": "LinkedField",
          "name": "addons",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addonID",
              "storageKey": null
            },
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v2/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "marketplace",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "canReadChannels",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "ignoreNoneECommerce",
              "value": true
            },
            {
              "kind": "Literal",
              "name": "status",
              "value": "ACTIVE"
            }
          ],
          "concreteType": "SalesChannel",
          "kind": "LinkedField",
          "name": "salesChannels",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EcommerceSettings",
              "kind": "LinkedField",
              "name": "ecommerceSettings",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isMarketplace",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "remoteUrl",
                  "storageKey": null
                },
                (v1/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShopifyAuthEcommerceSettings",
      "kind": "LinkedField",
      "name": "shopifyAuthEcommerceSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "environment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "installed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTestStore",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shop",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "16b17ea4828a3b8c120832f0d164c458";

export default node;
